<template>
  <div class="container mx-auto bg-white py-6 px-4 shadow">
    <form v-on:submit="submit">
      <textarea
        rows="5"
        class="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300
        rounded-md shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
        :disabled="!!image"
        v-model="text"
        placeholder="Paste text here"
      />
      <div>
        <button
          v-if="!!text"
          @click="removeText"
          class="mr-4 py-2 px-4
          rounded-full border-0
          text-sm font-semibold
          text-red-700
          hover:bg-red-50 mt-1"
        >
          X Remove text
        </button>
      </div>

      <div class="my-2 font-semibold">OR</div>

      <div class="relative">
        <p class="absolute left-0 top-0 m-2 italic text-sm">Drag and drop file here</p>
        <input
          :disabled="!!text"
          type="file"
          @change="uploadFile"
          ref="file"
          accept="image/png, image/jpeg, image/webp"
          class="block w-full text-sm text-slate-500
          bg-slate-50 py-16 px-2
          file:mr-4 file:py-2 file:px-4
          file:rounded-full file:border-0
          file:text-sm file:font-semibold
          file:bg-blue-100 file:text-blue-700
          hover:file:bg-blue-200 cursor-pointer"
        />
      </div>
      <div>
        <button
          v-if="!!image"
          @click="removeFile"
          class="mr-4 py-2 px-4
          rounded-full border-0
          text-sm font-semibold
          text-red-700
          hover:bg-red-50 mt-1"
        >
          X Remove image
        </button>
      </div>

      <div>
        <button type="submit" class="bg-blue-600 text-white px-4 py-1 mt-4 rounded">Upload!</button>
      </div>
      <div>
        <span v-if="error">{{ error }}</span>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    eventId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      text: "",
      image: "",
      error: null,
      isSubmitting: false,
    };
  },
  methods: {

    compressImage(path) {
      const img = new Image
      const c = document.createElement('canvas')
      const ctx = c.getContext('2d')

      return new Promise(resolve => {
        img.onload = function () {
          c.width = this.naturalWidth
          c.height = this.naturalHeight
          ctx.drawImage(this, 0, 0)
          const data = c.toDataURL('image/jpeg', 0.8);
          resolve(data);
        }
        img.src = path
      });
    },
    uploadFile() {
      const fileObject = this.$refs.file.files[0];
      const reader = new FileReader();
      reader.onload = async (e) => {
        this.image = await this.compressImage(e.target.result);
      };
      reader.readAsDataURL(fileObject);
    },
    removeFile() {
      this.image = "";
      this.$refs.file.value = "";
    },
    removeText() {
      this.text = "";
    },
    async submit(event) {
      event.preventDefault();
      this.isSubmitting = true;
      this.error = null;

      const data = new FormData();
      data.append('event_id', this.eventId);
      if (!!this.text) {
        data.append("data", this.text);
        data.append("type", "text");
      } else {
        // this.image is set
        data.append("data", this.image);
        data.append("type", "image");
      }

      try {
        await axios({
          method: "post",
          url: "/content/upload",
          data,
          headers: {"Content-Type": "multipart/form-data"},
        });

        event.target.reset();
        this.image = "";
        this.text = "";
      } catch (err) {
        console.error("Error", err);
        this.error = err.message;
      }

      this.isSubmitting = false;
    },
  },
};
</script>
